import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { RuleReducer } from './reducer';
import { RuleEffects } from './effects';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('rule', RuleReducer),
    EffectsModule.forFeature([RuleEffects])
  ]
})
export class RuleStoreModule { }
